import { useEffect, useState } from 'react';
import ReactGA from 'react-ga4';
import { useLocation } from 'react-router-dom';
import { useGetUserProfile } from '../../user/useGetUserProfile';

const isDevelopment =
  process.env.REACT_APP_CLIENT_ENVIRONMENT === 'development' || process.env.REACT_APP_CLIENT_ENVIRONMENT === 'local';

export const useGA = () => {
  const location = useLocation();
  const [initialized, setInitialized] = useState(false);
  const { userProfile } = useGetUserProfile();

  useEffect(() => {
    if (process.env.REACT_APP_GA_ID) {
      ReactGA.initialize(process.env.REACT_APP_GA_ID);
      setInitialized(true);
    }
  }, []);

  useEffect(() => {
    if (initialized) {
      ReactGA.send({
        hitType: 'pageview',
        path: `${window.location.origin}${location.pathname}`,
        location: `${window.location.origin}${location.pathname}`,
        title: `${window.location.origin}${location.pathname}`,
      });
    }
  }, [location, initialized]);

  useEffect(() => {
    if (userProfile?.id) {
      ReactGA.set({ userId: userProfile?.id });

      const pvmUserProperties = {
        pvm_user_logged_in: true,
        pvm_advertisement_term_agreed: userProfile?.advertisementTermsAgreement,
        pvm_user_id: userProfile?.id,
        pvm_user_email: userProfile?.email,
        pvm_user_phone_number: userProfile?.phoneNumber,
        pvm_user_region: `${userProfile?.regionDepth1} ${userProfile?.regionDepth2} ${userProfile?.regionDepth3}`,
      };

      if (window.gtag) {
        window.gtag('set', 'user_properties', pvmUserProperties);
      }
    } else {
      ReactGA.set({ userId: undefined });
    }
  }, [userProfile]);
};
